export const getEmptyBlocksInGrid = ({
  gridSize,
  content
}) => {
  const grid = Array.from({ length: gridSize.rows ?? 0 }, () => Array(gridSize.cols ?? 0).fill(false))

  content?.forEach(({ cords = { x: 0, y: 0 }, size }) => {
    for (let y = cords.y; y < cords.y + size.rows; y++) {
      for (let x = cords.x; x < cords.x + size.cols; x++) {
        if (y < gridSize.rows && x < gridSize.cols) grid[y][x] = true
      }
    }
  })

  const visited = Array.from({ length: gridSize.rows }, () => Array(gridSize.cols).fill(false))
  const result = []

  const floodFill = (startY, startX) => {
    const stack = [[startY, startX]]
    const cells = []

    while (stack.length) {
      const [y, x] = stack.pop()
      if (y < 0 || x < 0 || y >= gridSize.rows || x >= gridSize.cols) continue
      if (grid[y][x] || visited[y][x]) continue

      visited[y][x] = true
      cells.push([y, x])

      stack.push([y + 1, x], [y - 1, x], [y, x + 1], [y, x - 1])
    }

    return cells
  }

  for (let y = 0; y < gridSize.rows; y++) {
    for (let x = 0; x < gridSize.cols; x++) {
      if (!grid[y][x] && !visited[y][x]) {
        const cells = floodFill(y, x)
        const xs = cells.map(([_, cx]) => cx)
        const ys = cells.map(([cy]) => cy)
        const minX = Math.min(...xs)
        const maxX = Math.max(...xs)
        const minY = Math.min(...ys)
        const maxY = Math.max(...ys)
        result.push({ x: minX, y: minY, cols: maxX - minX + 1, rows: maxY - minY + 1 })
      }
    }
  }

  return result.map(({ x, y, cols, rows }, index) => ({
    id: `emptyBlock_${index}`,
    size: { cols, rows },
    cords: { x, y },
    isEmptyBlock: true
  }))
}
